import React from 'react';
import { CloseCircleRed } from '../../../common/icons/CloseCircleRed';
import { Calendar } from '../../../common/icons/Calendar';
import DatePicker from 'react-datepicker';
import {
  CalendarIconContainer,
  InputContainer,
  MyAuditDatePickerContainer,
} from '../../sharedStyledComponents/Datepicker.styled';
import { IDatePicker } from '../../../@types/datePicker';

export function DatePickerDate ({ startDate, setStartDate }: IDatePicker) {
  return (
    <MyAuditDatePickerContainer>
      <InputContainer>
        <DatePicker
          className={`myaudit-filter-date-picker`}
          popperClassName="date-picker-popper"
          dateFormat="dd-MM-yyyy"
          onFocus={(event) => event.target.blur()}
          placeholderText="Date"
          selected={startDate && new Date(startDate)}
          onChange={(selectedDate) => {
            setStartDate(selectedDate);
          }}
        />
        <CalendarIconContainer>
          {startDate ? (
            <CloseCircleRed onClick={() => setStartDate(undefined)} />
          ) : (
            <Calendar />
          )}
        </CalendarIconContainer>
      </InputContainer>
    </MyAuditDatePickerContainer>
  );
}
